import Vue from "vue";
import { MarketingRepo } from "@core/repositories";
import CORE_CONFIG from "@core/config/app.config.js";
import { $users, $preferences } from "@core/services/";
import accounts from '@core/services/accounts.js'
import buildPrivatePub from "@core/plugins/privatePub";
import { extractCluster, verifyAccountCluster } from "@core/config/utils";
import { userProductAccess,refreshToken } from '@core/config/utils'
import jwtDecode from "jwt-simple";
import router from "@/router";
import uniqBy from "lodash/uniqBy";
import isEmpty from "lodash/isEmpty";
import moment from 'moment-timezone';
export default {
  namespaced: true,
  strict: true, 
  state: {
    username: "",
    requestedUrl: "",
    requestedUrlQuery: {},
    token: null,
    loggedIn: false,
    userdata: {},
    userIndustry: null,
    defaultAccount: null,
    iframeDocument: null,
    userAccess: {},
    account: {
      id: null,
      name: null,
      current: null,
      list: [],
      ids: [],
      pagination: {
        page: 0,
        per_page: 10,
        ids: [],
      },
    },
    editAccountId: "",
    roles: [],
    packageFeatures: {},
    channelSignature: {},
    enableProductsRevenue: true,
    enableSecureList: true,
    connectorAppData: {},
    maropostIdentityToken: null,
    serviceCloudPackage:null,
    preferences: {
      default_account_id: "",
      subscribe_to_newsletter: false,
      subscribe_to_status_update: false,
      subscribe_to_release_notes: false,
      subscribe_to_research_panel: false,
      subscribe_to_pac: false,
      enable_notifications: false,
      widgets_position: [],
      time_zone: "America/New_York",
      timezone_offset: null
    },
  },
  actions: {
    logout({ commit }, redirectOnClear) {
      commit("ui/layout", "Auth");
      commit("logout", redirectOnClear);
    },
    async getRoles({ commit,getters }) {
      $users.getRoles().then((response) => {
        commit("roles", response.data.data.roles);
        //check if user have access to current route
        if(router.currentRoute.meta.module){
          if(!getters.checkRole(router.currentRoute.meta.module)){
            router.push('/access-denied')
          }
        }
      });
    },
    async getPreferences({ commit, state }) {
      try {
        await refreshToken();
        const response = await Vue.prototype.$keycloak.loadUserProfile();
        let name = {firstName : response.firstName ? response.firstName : '',
                    lastName:response.lastName ? response.lastName : '' 
                  }
        commit("username",name)
        if(response.attributes && response.attributes.preferences && response.attributes.preferences[0]){
          let preferences = JSON.parse(response.attributes.preferences[0])
          if(!preferences.time_zone)
            preferences.time_zone = "America/New_York"
          /*** add timezone */
          let timeZoneOffset = moment.tz(preferences.time_zone).format('Z');
          // Get the UTC offset in minutes
          let minutesOffset = moment().utcOffset(timeZoneOffset).utcOffset();
          // Convert minutes to hours
          let decimalOffset = minutesOffset / 60;
          preferences.timezone_offset = decimalOffset;
          commit("setPreferences", preferences);
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getAccountList({ commit }) {
      $users.getAccountList().then((response) => {
        let accountList = [];
        if ("data" in response && "data" in response.data) {
          let cluster = extractCluster(response.config.baseURL);
          accountList = response.data.data.map((account) => {
            account.cluster = cluster;
            return account;
          });
        }

        commit("account.list", accountList);
      });
    },
    async getAccountInfo({ commit, state }, params=null) {
      let config = null
      if(params){
        params = {
          accountId: state.account.id,
          successHandler: null,
          errorHandler: null,
          ...params
        }
        
        let baseURL = `${CORE_CONFIG.RAILS_BASE_URL}/v2/${params.accountId}`;
        if("cluster" in params){
          baseURL = verifyAccountCluster(params, true) + `/v2/${params.accountId}`
        }

        config = { baseURL }
      }
      $users.getAccountInfo(config).then((response) => {
        let cluster = extractCluster(response.config.baseURL);
        switch (cluster) {
          case "api-eu1":
            cluster = "europe";
            break;
          case "api-ca1":
            cluster = "canada";
            break;
        }
        if (!("data" in response && "data" in response.data)) return;

        let accountInfo = response.data.data.account;
        if("customer_id" in accountInfo){
          delete accountInfo.customer_id
        }
        accountInfo.id = accountInfo.account_id || accountInfo.id;
        accountInfo.cluster = cluster;
        let accountList = state.account.list;
        if (
          "default_account_id" in state.preferences &&
          state.preferences.default_account_id &&
          state.preferences.default_account_id == accountInfo.id
        ) {
          commit("userIndustry", accountInfo.industry);
          commit("defaultAccount", accountInfo.industry);
        }

        let account = accountList.find((i) => i.id == accountInfo.id);
        if (account) {
          account = { ...account, ...accountInfo }
        }

        accountList.splice(accountList.findIndex(item=>item.id == account.id), 1, account)
        commit("account.list", accountList);
        params && params.successHandler && params.successHandler()
      }).catch(err=>{
        console.error(err)
        params && params.errorHandler && params.errorHandler(err);
      });
    },
    async getPackageFeatures({ commit }) {
      $users.getPackageFeatures().then((response) => {
        commit("package.features", response.data.data);
      });
    },
    async getServiceCloudPackage({ commit }, payload = {}) {
      const { customerId, ...config } = payload;
      const { data } = await accounts.subscriptionDetails(customerId, config);
    
      const details = !isEmpty(data.data) ? data.data[0] : {};
      commit("setServiceCloudPackage", details);
    }
  },
  mutations: {
    setServiceCloudPackage(state,data){
      state.serviceCloudPackage = data
    },
    roles: (state, value) => {
      value.push("segments");
      state.roles = value;
      if (
        value.includes("campaigns") &&
        !value.includes("campaign_edit_schedule") &&
        !value.includes("campaign_requires_approval") &&
        !value.includes("campaign_full_access")
      ) {
        state.roles.push("campaign_full_access");
      }
      state.userAccess = userProductAccess(state.roles)
    },
    loggedIn: (state, value) => (state.loggedIn = value),
    editAccountId: (state, value) => (state.editAccountId = value),
    userdata: (state, value) => (state.userdata = value),
    username: (state, value) => (state.username = value),
    userIndustry: (state, value) => (state.userIndustry = value),
    defaultAccount: (state, value) => (state.defaultAccount = value),
    "userdata.default_account_id": (state, value) =>
      (state.userdata.default_account_id = value),
    "userdata.first_name": (state, value) =>
      (state.userdata.first_name = value),
    "userdata.last_name": (state, value) => (state.userdata.last_name = value),
    token: (state, value) => (state.token = value),
    "iframe.document": (state, value) => (state.iframeDocument = value),
    "account.pagination": (state, value) => {
      state.account.pagination = value;
    },
    "account.ids": (state, value) => {
      state.account.ids.push(value);
    },
    "account.current": (state, value) => {
      state.account.current = value;
    },
    "account.list": (state, value) => {
      value = uniqBy(value, "id");
      value = value == undefined || value == null ? [] : value;
      state.account.list = value.map((account) => {
        if (!account.cluster) {
          account.cluster = extractCluster(MarketingRepo.defaults.baseURL);
        }
        return account;
      });
      state.account.ids = value.map((account) => account.id);
      if (state.account.list.length && state.account.id) {
        const account = state.account.list.find(
          (item) => item.id === state.account.id
        );
        if (account) {
          state.account.name = account.name;
          state.account.current = account;
        }
      }
    },
    "account.id": (state, value) => {
      state.account.id =
        value == undefined || value == "" ? null : parseInt(value);
      MarketingRepo.defaults.baseURL = `${CORE_CONFIG.RAILS_BASE_URL}/v2/${state.account.id}`;
      if (state.account.list.length && value) {
        const account = state.account.list.find(
          (item) => item.id === state.account.id
        );
        if (account) {
          state.account.name = account.name;
          state.account.current = account;
          verifyAccountCluster(state.account.current);
        }
      }
    },
    "package.features": (state, value) => {
      state.packageFeatures = value;
      if (!value.products_and_revenue) state.enableProductsRevenue = false;
      else {
        if (value.account_setting) {
          const setting = value.account_setting;
          if (setting.package_feature) {
            state.enableProductsRevenue =
              setting.package_feature.products_and_revenue === "yes";
          } else state.enableProductsRevenue = true;
        }
      }
      if (!value.enable_secure_suppression_list) state.enableSecureList = false;
      else {
        if (value.account_setting) {
          const setting = value.account_setting;
          if (setting.package_feature) {
            state.enableSecureList =
              setting.package_feature.secure_suppression_lists === "yes";
          } else state.enableSecureList = true;
        }
      }
    },
    logout: (state, redirectOnClear = true) => {
      state.token = null;
      state.loggedIn = false;
      state.roles = [];
      state.editAccountId = "";
      state.userdata = {};
      state.userIndustry = null;
      state.defaultAccount = null;
      state.location = null;
      state.account.current = null;
      state.account.id = null;
      state.account.list = [];
      state.account.ids = [];
      state.account.pagination.page = 0;
      state.name = null;
      state.list = [];
      state.username = "";
      state.maropostIdentityToken = null;
      localStorage.clear();
      if (buildPrivatePub.fayeClient) {
        buildPrivatePub.resetConnection();
      }
      
    },
    connectorAppData: (state, value) => (state.connectorAppData = value),
    setMaropostIdentityToken: (state, token) => {
      let tokenInfo = jwtDecode.decode(token, "", true);
      if (tokenInfo && "email" in tokenInfo) {
        state.userdata = {
          ...state.userdata,
          email: tokenInfo.email,
        };
      }
    },
    setPreferences: (state, value) => (state.preferences = value),
  },
  getters: {
    loggedIn: (state) => state.loggedIn,
    serviceCloudPackage: (state) => state.serviceCloudPackage || {},
    editAccountId: (state) => state.editAccountId,
    roles: (state) => state.roles,
    userdata: (state) => state.userdata,
    username: (state) => state.username,
    userIndustry: (state) => state.userIndustry,
    defaultAccount: (state) => state.defaultAccount,
    account: (state) => state.account,
    token: (state) => state.token,
    "iframe.document": (state) => state.iframeDocument,
    checkRole: (state) => (role) => {
      if(role === 'mobile') {
                    //!! used to convert return value into boolean
        return !!(state.roles.includes(role) &&
        state.packageFeatures.visible_menus.includes(role) && 
        (state.packageFeatures.from_number && state.packageFeatures.from_number.length))
      } else {
        if(!role) return true;
        if(typeof role === 'string')
          return state.roles.length ? state.roles.includes(role) : true

        return (role.filter(value => state.roles.includes(value))).length>0
      }
    },
    checkMobileOnly: (state) => (role) => {
      if(role === 'mobile') {
        return !!(state.roles.includes(role) &&
        state.packageFeatures.visible_menus.includes(role))
      } else {
        return state.roles.includes(role)
      }
    },
    "account.current": (state) => state.account.current,
    "account.id":(state) => state.account.id,
    connectorAppData: (state) => state.connectorAppData,
    isFreeTrial: (state) => {
      return (
        state.packageFeatures.account_setting &&
        state.packageFeatures.account_setting.package_type === "free_trial"
      );
    },
    maropostIdentityToken: ({ maropostIdentityToken }) => maropostIdentityToken,
    hasFeatureAccess: (state) => (feature) => {
      const accountSetting = state.packageFeatures.account_setting;
      /**
       * According to application behavior we considering all features are active for the account.
       * add null check as per https://maropost.atlassian.net/browse/ANC-938
       */
      if (
        accountSetting &&
        (accountSetting.package_type === null ||
          accountSetting.package_type.length === 0)
      ) {
        return true;
      }
      if (
        accountSetting &&
        accountSetting.package_feature &&
        accountSetting.package_feature[feature]
      ) {
        return accountSetting.package_feature[feature] === "yes";
      }
      return false;
    },
    packageFeatures: (state) => state.packageFeatures,
    userEmail: (state) => state.userdata && state.userdata.email,
    preferences: (state) => state.preferences,
    userAccess: (state) => state.userAccess,
  },
};
